import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { getErrorHash } from '@atlassian/jira-errors-handling';
import { useIntl } from '@atlassian/jira-intl';

import errorImg from './assets/generic-error.svg';
import messages from './messages';

type FallbackProps = {
	error: Error;
};

export const Fallback = (props: FallbackProps) => {
	const { error } = props;
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={WrapperStyles} alignInline="center" space="space.100">
			<ImgWrapper alt="" src={errorImg} />
			<Heading size="xsmall">{formatMessage(messages.errorHeading)}</Heading>
			<>{formatMessage(messages.errorBody)}</>
			<Box xcss={ErrorStyles} as="code" paddingBlock="space.025" paddingInline="space.050">
				ERROR: {getErrorHash(error)}
			</Box>
		</Stack>
	);
};

const WrapperStyles = xcss({
	backgroundColor: 'color.background.neutral',
	color: 'color.text.subtle',
	padding: 'space.200',
	textAlign: 'center',
});

const ErrorStyles = xcss({
	borderRadius: 'border.radius.050',
	fontSize: '0.7em',
	color: 'color.text.subtlest',
	backgroundColor: 'color.background.accent.gray.subtler',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImgWrapper = styled.img({
	height: '50px',
});
